import './RegionSubscribe.scss';

const initRegionSubscribe = () => {
  const blocks = document.querySelectorAll('[data-region-subscribe]');

  Array.from(blocks).forEach((block) => {
    const form = block.querySelector('[data-subscription-block]');
    const defaultState = block.querySelector('[data-region-subscribe-default]');
    const successState = block.querySelector('[data-region-subscribe-success]');
    const emailNode = block.querySelector('[data-subscribed-email]');

    form.addEventListener('subscribed', (event) => {
      emailNode.textContent = event.detail.email;
      defaultState.classList.add('-hidden');
      successState.classList.remove('-hidden');
    });
  });
};

initRegionSubscribe();
